import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PanelMenuModule } from "primeng/panelmenu";
import { TabViewModule } from "primeng/tabview";
import { TieredMenuModule } from "primeng/tieredmenu";
import { SubMenuComponent } from "../menu/sub-menu/sub-menu.component";
import { MenuComponent } from "./menu/menu.component";
import { StepsMenuComponent } from "./steps-menu/steps-menu.component";
import { TabMenuComponent } from "./tab-menu/tab-menu.component";
import { TabPanelComponent } from "./tab-menu/tab-panel.component";
import { TieredMenuComponent } from "./tiered-menu/tiered-menu.component";


@NgModule({
  imports: [
    CommonModule,
    PanelMenuModule,
    TieredMenuModule,
    TabViewModule,
  ],
  declarations: [
    MenuComponent,
    TieredMenuComponent,
    SubMenuComponent,
    TabMenuComponent,
    TabPanelComponent,
    StepsMenuComponent,
  ],
  exports: [
    MenuComponent,
    TieredMenuComponent,
    SubMenuComponent,
    TabMenuComponent,
    TabPanelComponent,
    StepsMenuComponent,
  ],
})
export class MenuModule { }
